








































import { Vue, Component, Prop } from "vue-property-decorator";
import { LectureVideo as ILectureVideo } from "@/api/models/lecture-video";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
@Component
export default class lectureVideoView extends Vue {
  @Prop() videos?: Array<ILectureVideo>;
  @Prop({ default: false }) isLecture?: boolean;
  currentVideo!: ILectureVideo | undefined;
  currentIndex: number = 0;
  data() {
    return {
      currentVideo: undefined
    };
  }

  beforeMount() {
    document.addEventListener("keyup", this.handleKeydown);
  }
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleKeydown);
  }

  handleKeydown(e: any) {
    if (e.code === "ArrowRight") {
      if (this.videos && this.currentIndex < this.videos.length - 1) {
        this.getCurrentSlide(this.currentIndex + 1);
      }
    }
    if (e.code === "ArrowLeft") {
      if (this.currentIndex !== 0) {
        this.getCurrentSlide(this.currentIndex - 1);
      }
    }
  }

  getMethodByProp(index: number) {
    let method: any;

    if (this.isLecture && this.videos?.length)
      method = api.LectureVideoApi.get(
        this.$route.params.id,
        this.videos[index].id
      );

    if (!this.isLecture && this.videos?.length)
      method = api.CourseLectureApi.getVideo(
        this.$route.params.courseId,
        this.$route.params.courseLectureId,
        this.videos[index].id
      );

    return method;
  }

  getCurrentSlide(index: number = 0) {
    this.currentIndex = index;
    this.currentVideo = undefined;
    if (this.videos) {
      this.getMethodByProp(index)
        .then((res: { data: ILectureVideo }) => {
          this.currentVideo = res.data;
          this.$emit("scrollToUp");
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  created() {
    this.getCurrentSlide();
  }
}
